import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';

const BASE_URL = COMMUNITY_ENDPOINTS.NOTIFICATIONS;

export const getAll = (params = {}) =>
  communityHttpClient.get(`${BASE_URL}/`, { params });

export const getUnreadCount = () =>
  communityHttpClient.get(`${BASE_URL}/unread_count/`);

export const markRead = (id) =>
  communityHttpClient.post(`${BASE_URL}/${id}/mark_read/`);

export const markAllRead = () =>
  communityHttpClient.post(`${BASE_URL}/mark_all_read/`);

export default { getAll, getUnreadCount, markRead, markAllRead };
